import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class PaymentLinkShowRoute extends Route {
  @service router;
  @service fastboot;
  @service store;
  @service currentPractice;
  @service paymentLinkState;
  @service('session') clientPortalSession;
  @service analytics;

  model(params) {
    if (this._isSmsEnabled && !this.paymentLinkState.isDobVerified) {
      return this.paymentLinkState.unverifiedPaymentLinkObject;
    }

    return this.store.adapterFor('payment-link').queryRecord(params.uuid, { reload: true });
  }

  async beforeModel(transition) {
    if (this.fastboot.isFastBoot) {
      return;
    }

    if (!this._isPaymentLinkEnabled) {
      this.router.transitionTo('not-found', 'errors/404');
      return;
    }

    if (this._isSmsEnabled) {
      await this.paymentLinkState.requirePaymentLinkSession();
    } else {
      this.clientPortalSession.requireAuthentication(transition, 'home');
    }
  }

  afterModel(model, transition) {
    if (
      transition.from?.name === 'sign-in.token.verify' &&
      model.status === 'active' &&
      !this._isSmsEnabled
    )
      this._trackPaymentLinkSignIn(model);
  }

  STATUS_COMPONENT_MAP = {
    unverified: 'verification-step',
    active: 'payment-form',
    paid: 'paid',
    expired: 'expired',
  };

  setupController(controller, model) {
    super.setupController(...arguments);

    let component = this.STATUS_COMPONENT_MAP[model.status];
    const module = importSync(`../../components/payment-link/${component}`);

    controller.set('containerComponent', ensureSafeComponent(module.default, this));
  }

  get _isPaymentLinkEnabled() {
    return this.currentPractice.get('featurePaymentLinks');
  }

  get _isSmsEnabled() {
    return this.currentPractice.get('featurePaymentLinksSms');
  }

  _trackPaymentLinkSignIn(model) {
    // eslint-disable-next-line camelcase
    this.analytics.track('Payment Link Clicked', { payment_link_id: model.uuid });
  }
}
